const convertDistance = (mi: string) => {
  switch (mi) {
    case '5':
      return '8.05';
    case '10':
      return '16.09';
    case '25':
      return '40.23';
    case '50':
      return '80.47';
    default:
      return '16.09';
  }
};

export { convertDistance };
